import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Collection, ForEachModel, WhenCollectionIsNotEmpty, WhenModelValue } from '@morningtrain/react-resources'
import { StaticFilter } from '@morningtrain/react-filters'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'
import * as Displays from 'support/displays'
import Smartview from 'widgets/smartviews/Smartview'
import DashboardSmartviewNavigation from 'widgets/dashboard/smartviews/DashboardSmartviewNavigation'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'

export default function MyShiftsSmartview () {
  return (
    <Can permission='api.shifts.schedule_slot.mine'>
      <Widget>
        <Translator namespace='dashboard.my_shifts'>
          <Smartview>
            <DashboardSmartviewNavigation active='my_shifts' />
            <Collection resourceName='shifts.schedule_slot' operationName='mine'>
              <StaticFilter name='upcoming' value />
              <SelectedDepartmentFilter />
              <WhenCollectionIsNotEmpty>
                <div>
                  <SmartviewHeader>
                    <UI.SecondaryHeading>
                      <Translation name='title' />
                    </UI.SecondaryHeading>
                  </SmartviewHeader>
                  <SmartviewTextGroup highlight highlightSize='card'>
                    <ForEachModel>
                      <SmartviewText
                        outerClassName='py-2'
                        label={(
                          <UI.Text capitalize weight='medium'>
                            <Displays.Date name='start_at' dateFormat='dddd DD/MM/YYYY' />
                          </UI.Text>
                        )}
                      >
                        <UI.SpaceBetween>
                          <UI.Text>
                            <Displays.Time name='start_at' forceUTC />
                            <span> - </span>
                            <Displays.Time name='end_at' forceUTC />
                          </UI.Text>
                          <UI.Text>
                            <Displays.Text name='department_name' />
                          </UI.Text>
                        </UI.SpaceBetween>
                        <div className='flex'>
                        <WhenModelValue name='note'>
                          <UI.Text block className='mt-1'>
                            <Displays.Text name='note' />
                          </UI.Text>
                        </WhenModelValue>
                          <UI.Text className='flex ml-auto justify-end'>
                            <Displays.Enum name="category" enum="employment_type_category"/>
                          </UI.Text>
                        </div>
                      </SmartviewText>
                    </ForEachModel>
                  </SmartviewTextGroup>
                </div>
              </WhenCollectionIsNotEmpty>
            </Collection>
          </Smartview>
        </Translator>
      </Widget>
    </Can>
  )
}
